import { IField } from '../../constants'
import React, { useEffect, useState } from 'react'
import { ErrorLabel, FormItem } from '../../style'
import { Form } from 'react-bootstrap'
import { DescriptedLabel } from 'iebt-zing-storybook'

export function BuildCheckbox(item: IField, itemKey): JSX.Element {
  const [checked, setChecked] = useState<boolean>(item.value ?? false)

  useEffect(() => {
    if (item.value == null) {
      setChecked(true)
      item.value = true
      item.updateFieldState?.(item)
    }
  }, [item])

  const handleCheckboxChange = (newValue: boolean): void => {
    setChecked(newValue)
    item.value = newValue
    item.updateFieldState?.(item)
  }

  return (
    <FormItem key={itemKey}>
      <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
        <Form.Check
          onChange={() => handleCheckboxChange(true)}
          disabled={item.disabled}
          id={item.id}
          checked={checked}
          label={<span style={{ fontWeight: 'bold' }}>{item.positiveLabel}</span>}
        />
        <Form.Check
          onChange={() => handleCheckboxChange(false)}
          disabled={item.disabled}
          id={item.id + '-neg'}
          checked={!checked}
          label={<span style={{ fontWeight: 'bold' }}>{item.negativeLabel}</span>}
        />
      </div>
      <ErrorLabel className={`errors-${item.id}`} />
    </FormItem>
  )
}
